import PropTypes from 'prop-types';

const JuristecLogoNew = ({ width = '25px', height = '25px' }) => (
  <svg width={width} height={height} viewBox="0 0 193 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_30_120)">
      <path d="M58.4347 139.699C54.508 139.699 51.708 135.852 52.8827 132.069L64.5653 94.4159C65.3253 91.9653 67.5733 90.2973 70.1173 90.2973H89.8867V-6.63965e-05L50.184 11.4373V105.055C50.184 132.016 41.1 145.497 22.9347 145.497C14.4667 145.497 6.82267 142.908 0 137.729V175.089C7.892 178.295 16.48 179.897 25.7707 179.897C46.5653 179.897 62.452 173.609 73.4253 161.033C78.5653 155.144 82.484 148.021 85.2173 139.699H58.4347Z" fill="#5602C1" />
      <path d="M143.23 131.101V179.897H110.918V131.101H62.3833L71.898 98.7888H110.918V50.2541H143.23V98.7888H192.026V131.101H143.23Z" fill="#FF8600" />
    </g>
    <defs>
      <clipPath id="clip0_30_120">
        <rect width="192.026" height="179.897" fill="white" />
      </clipPath>
    </defs>
  </svg>

);

JuristecLogoNew.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default JuristecLogoNew;
